module.exports = __webpack_public_path__ + "img/3.6f0b9a73.png";